import React, { Component, ReactNode } from "react";
import "./CloseableModal.css";
import IconButton from "../theme_reuse/IconButton";

const MINI_WIDTH = 200;

interface Props {
  mini?: boolean;
  centerX?: number;
  centerY?: number;
  children: React.ReactNode;
  onClose: () => void;
}
interface State {
  pageHeight: number;
}
class CloseableModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      pageHeight: 300,
    };
  }
  handleBodyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  focusRef = React.createRef<HTMLButtonElement>();

  componentDidMount() {
    // Whenever a popup opens, focusing the X achieves (1) can tab to first option (2) can spacebar to close
    if (this.focusRef?.current) {
      this.focusRef.current.focus();
    }
    if (this.state.pageHeight !== document.documentElement.scrollHeight) {
      this.setState({
        pageHeight: document.documentElement.scrollHeight,
      });
    }
  }

  render(): ReactNode {
    const { mini, centerX, centerY } = this.props;
    const { pageHeight } = this.state;
    const miniClass = mini ? "mini-modal" : "";
    const positionStyles =
      centerX && centerY ? { top: Math.max(0, centerY - MINI_WIDTH), left: Math.max(0, centerX - MINI_WIDTH) } : undefined;
    const backgroundStyle = { height: `${pageHeight}px` };

    return (
      <div className={`closeable-modal-background ${miniClass}`} style={backgroundStyle} onClick={this.props.onClose}>
        <div className="closeable-modal" onClick={this.handleBodyClick} style={positionStyles}>
          <div className="closeable-modal-x-btn">
            <IconButton
              ref={this.focusRef}
              title="Close (or press Escape, or click outside of the popup)"
              icon={"X"}
              onClick={this.props.onClose}
            />
          </div>
          <div className="closeable-modal-text-content">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default CloseableModal;
